import { useState, useEffect } from 'react';
import { apiClient } from '../api/client';

interface MobileBottomNavConfig {
  enabled: boolean;
}

export function useMobileBottomNavConfig() {
  const [enabled, setEnabled] = useState(true); // default ON
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient<MobileBottomNavConfig>('/mobile-bottom-nav-config')
      .then((config) => setEnabled(config.enabled))
      .catch(() => setEnabled(true)) // fail-open for this feature
      .finally(() => setLoading(false));
  }, []);

  return { enabled, loading };
}
